import { PartialMessage } from '@bufbuild/protobuf';

import { ProductModel } from 'protocol/api/billing_new/dto_product_new_pb';

import { RootState } from '@/app/model/store';

import { productEditorAdapter } from './productEditorSlice';

const productEditorSelectors = productEditorAdapter.getSelectors(
  (state: RootState) => state.productEditor,
);

export const selectProductEditorLoading = (state: RootState) => state.productEditor.loading;

export const selectProductForUpdate = (state: RootState) => {
  const raw = state.productEditor.productForUpdate;

  if (!raw || !raw.SKU) {
    return raw;
  }

  return new ProductModel(raw as PartialMessage<ProductModel>);
};

export const selectEditorMode = (state: RootState) => state.productEditor.editorMode;

export const selectBillingZone = (state: RootState) => state.productEditor.billingZone;

export const { selectAll } = productEditorSelectors;
